
import { others } from "../../../styles/colors";
import colors from "../../../styles/colors/colors";
import fontWeight from "../../../styles/mui/fontWeight";
export const boxStyle = {
  borderRadius: "4px",
  background: colors.backgroundColor[2],
  boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.17)",
  padding: "20px",
  margin:"30px"
};

export const HeaderLabelStyle = {
    backgroundColor: colors.backgroundColor[8],
    fontSize: "14px",
    fontWeight : fontWeight.Weight[5],
    fontStyle: "normal",
    paddingTop: "10px",
    paddingBottom: "10px",
}
export const TableRowStyle = {
    fontSize: "14px",
    fontWeight : fontWeight.Weight[4],
    fontStyle: "normal"
}

export const CenterTypography = () => ({
  display:"flex",
  alignItems: "center",
  padding: "0.7rem 0rem 1.5rem 1rem",
  flexDirection: "row",
  gap: "2rem",
});

export const FilterParameterGrid = () => ({
  paddingRight: "1.8rem",
});

export const AutoComplete = {
  width: "17rem",
  maxHeight: "0.5rem",
  borderBottom: others.otherColors[35],
  borderBottomWidth: "0.06rem",
   "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
};

export const SearchTitleGrid = () => ({
  paddingBottom: "0.5rem",
  marginRight:"2rem",
});

export const ModalTitle = {
  textTransform: "uppercase",
  paddingTop: "0.6rem",
  paddingBottom: "0.3rem",
};

export const IconBox = () => ({
  paddingTop: "0.2rem",
});

export const ContentBox = () => ({
  display: "flex",
  flexDirection: "row",
});

export const CancelProviderModalGrid = () => ({
  position: "absolute",
  left: "49%",
  top: "35%",
  transform: "translate(-50%, -50%)",
  width: "36%",
  height: "auto",
  bgcolor: "background.paper",
  padding: "1rem 1rem 1rem 1.5rem",
  borderRadius: "1.5rem",
  marginLeft: "1.5rem",
  zIndex: 10,
});

export const FooterBox = () => ({
  opacity: 1,
  margin: "0.5rem",
  display: "flex",
  paddingTop: "1rem",
  justifyContent: "end",
  width: "100%",
});

export const CancelButton = () => ({
  background: others.otherColors[33],
});

export const ClearServiceModalSubtitle = {
  paddingTop: "0.25rem",
};